import { ILoginAllLang } from '../../../types/lang'
import { loginFormLang } from './loginForm'


export const loginAllLang: ILoginAllLang = {
	...loginFormLang,
}